import React from "react";
import { Popper } from "react-popper";

class ModularButtonPopup extends React.Component {
  constructor(props) {
    super(props);
    this.state = { open: false };
    this.buttonRef = React.createRef();
    this.popupRef = React.createRef();
  }

  componentDidUpdate(prevProps, prevState) {
    if (!prevState.open && this.state.open) {
      document.addEventListener("mousedown", this.handleOutsideClick);
    } else if (prevState.open && !this.state.open) {
      document.removeEventListener("mousedown", this.handleOutsideClick);
    }
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleOutsideClick);
  }

  handleClick = () => {
    this.setState((prev) => ({ open: !prev.open }));
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  handleOutsideClick = (event) => {
    if (
      this.buttonRef.current &&
      this.buttonRef.current.contains(event.target)
    ) {
      return;
    }
    if (
      this.popupRef.current &&
      this.popupRef.current.contains(event.target)
    ) {
      return;
    }
    this.handleClose();
  };

  render() {
    const { label, children, className, popupClassName } = this.props;

    const injectOnClose = (child) => {
      if (
        child &&
        child.type &&
        (child.type.displayName === "TooltipButton" || child.type.name === "TooltipButton")
      ) {
        return React.cloneElement(child, {
          tooltipInPopup: true,
          tooltipBoundaryElement: this.popupRef.current,
          onClick: (...args) => {
            if (child.props.onClick) child.props.onClick(...args);
            this.handleClose();
          },
        });
      }
      
      if (child && child.props && child.props.children) {
        return React.cloneElement(child, {
          children: React.Children.map(child.props.children, injectOnClose),
        });
      }
      return child;
    };

    const processedChildren = React.Children.map(children, injectOnClose);

    return (
      <div style={{ display: "inline-block", position: "relative" }}>
        <button
          ref={this.buttonRef}
          onClick={this.handleClick}
          className={className}
          type="button"
        >
          {label}
        </button>
        <Popper referenceElement={this.buttonRef.current} placement="top">
          {({ ref, style, placement }) =>
            this.state.open && (
              <div
                ref={(node) => {
                  ref(node);
                  this.popupRef.current = node;
                }}
                style={{ ...style, zIndex: 9999 }}
                data-placement={placement}
                className={popupClassName}
                tabIndex={-1}
              >
                {processedChildren}
              </div>
            )
          }
        </Popper>
      </div>
    );
  }
}

export default ModularButtonPopup;
